import { render, staticRenderFns } from "./ComissaoDados.vue?vue&type=template&id=edcd8aa0&scoped=true"
import script from "./ComissaoDados.vue?vue&type=script&lang=js"
export * from "./ComissaoDados.vue?vue&type=script&lang=js"
import style0 from "./ComissaoDados.vue?vue&type=style&index=0&id=edcd8aa0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcd8aa0",
  null
  
)

export default component.exports